import * as MdIcons from 'react-icons/md';
import { useUploadProcessProvider } from "../../../../../Providers/UploadProcessProvider";
import { DataTypeContentContainer, TableHeaderText } from "../../../../../Constants/StyledComponents";
import ModernMUITable from "../../../../../Components/ModernMUITable";

const getColumns = label => {
	const columnMappings = {
		"Moberg Data": [
			{ field: "directoryName", flex: 1, headerName: "File name", minWidth: 200 },
			{ field: "fileSize", flex: 1, headerName: "File size", minWidth: 150 },
			{ field: "modalities", flex: 1, headerName: "No. measurements", minWidth: 150 },
		],
		Natus: [
			{ field: "directoryName", flex: 1, headerName: "File name", minWidth: 200 },
			{ field: "fileSize", flex: 1, headerName: "File size", minWidth: 150 },
		],
		Medications: [
			{ field: "directoryName", flex: 1, headerName: "File name", minWidth: 200 },
			{ field: "fileSize", flex: 1, headerName: "File size", minWidth: 150 },
			{ field: "nMedications", flex: 1, headerName: "No. medications", minWidth: 150 },
		],
		Form: [
			{ field: 'formName', flex: 1, headerName: 'Form name', minWidth: 200 }
		],
		EDF: [
			{ field: "directoryName", flex: 1, headerName: "File name", minWidth: 200 },
			{ field: "fileSize", flex: 1, headerName: "File size", minWidth: 150 },
		]
	}

	return columnMappings[label]
}


const UploadSummaryData = ({ label }) => {
	const uploadProcessProvider = useUploadProcessProvider()

	const columns = getColumns(label)

	const tableName = label === "Moberg Data" ? "cns" : label.toLowerCase()

	// Get table data based on label
	const tableData = label === 'Form' 
		? (uploadProcessProvider.submittedForm ? [uploadProcessProvider.submittedForm] : [])
		: (uploadProcessProvider[`${tableName}TableData`] || []);

	return (
		<DataTypeContentContainer>
			<div style={{ height: "300px", overflowY: "auto" }}>
				<ModernMUITable 
					columns={columns} 
					tableData={tableData}
					checkboxSelection={false}
					showToolbar={false}
					height="250px"
					paginationMode="client"
					sortingMode="client"
				/>
			</div>
		</DataTypeContentContainer>
	)
}

export default UploadSummaryData
